import React, { useEffect, useState } from 'react';
import {
  Create, SimpleForm, TextInput, NumberInput, SelectInput, required, useTranslate,
} from 'react-admin';
import { Box, CircularProgress, Grid, useTheme } from '@mui/material';
import { httpClient } from '@/utils/httpClient';
import { FormPageTitle, FormSection, FormToolbar } from '@/components/shell';

const BACK_TO = '/kyc-config?tab=default-mapping';

export const DefaultMappingCreate = () => {
  const t = useTranslate();
  const theme = useTheme();
  const [kycFields, setKycFields] = useState<Array<{ id: string; name: string }>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    httpClient.get<Array<{ id: string; name: string }>>('/admin/kyc-field/GetAllKYCFields')
      .then((r) => setKycFields(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  }

  return (
    <Create redirect={BACK_TO} actions={<FormPageTitle mode="create" />}>
      <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} />} defaultValues={{ priority: 0 }}>
        <FormSection title={t('resources.default-mapping.name', { smart_count: 1 })}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextInput
                source="standardFieldName"
                label={t('resources.default-mapping.fields.standardFieldName')}
                validate={required()}
                fullWidth
                InputProps={{ sx: { fontFamily: theme.custom.text.mono } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SelectInput
                source="kycFieldId"
                label={t('resources.default-mapping.fields.kycFields.name')}
                choices={kycFields}
                validate={required()}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <NumberInput
                source="priority"
                label={t('resources.default-mapping.fields.priority')}
                min={0}
                fullWidth
                helperText={t('screens.defaultMappings.priorityHelp')}
              />
            </Grid>
          </Grid>
        </FormSection>
      </SimpleForm>
    </Create>
  );
};
